export default __webpack_public_path__ + "static/media/441.a4ef21a8.png";